import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FontAwesome } from '../FontAwesome';
import { getActionForUrl } from '../../utilities/reduxLinks';
import { Link } from '../../containers/Link/index';

export const FooterLink = (props) => {
  const { link } = props;
  const target = link.get('target', null);

  const action = link.get('action') || getActionForUrl(link.get('href', ''));
  const content = (
    <>
      {link.get('icon', '') && <FontAwesome name={link.get('icon')} />}
      {link.get('text', '')}
    </>
  );

  const extraProps = {};
  if (target) {
    extraProps.target = target;
    extraProps.rel = 'noopener noreferrer';
  }

  return action ? (
    <Link to={action.toJS()} {...extraProps}>
      {content}
    </Link>
  ) : (
    <a href={link.get('href')} {...extraProps}>
      {content}
    </a>
  );
};
FooterLink.propTypes = {
  link: ImmutablePropTypes.mapContains({
    text: PropTypes.string.isRequired,
    href: PropTypes.string,
    action: ImmutablePropTypes.mapContains({
      type: PropTypes.string.isRequired,
    }),
    icon: PropTypes.string,
    target: PropTypes.string,
  }).isRequired,
};
